/** @jsx isolateComponent */
import { isolateComponent } from '@zapier/style-encapsulation';
import { daysFromNow } from '@zapier/date';
import { Alert, Link } from '@zapier/design-system';

import type { Result } from '../useAlertBanner/alertBannerNotificationsQuery';
import { BannerProps } from './types';

export const shouldRender = (data: Result['data']) => {
  const { isTeamAccount, teamAccountEndDate } = data.currentAccount;
  return (
    !isTeamAccount &&
    !!teamAccountEndDate &&
    daysFromNow(teamAccountEndDate) <= 7
  );
};

export const Component = function TeamsDowngraded(props: BannerProps) {
  const onUpgrade = () => {
    props.trackEvent('clicked teams downgraded banner');
  };
  return (
    <Alert
      layout={props.layout}
      title="You’ve recently canceled your Team plan"
      type="info"
    >
      <Link href="/app/checkout/upgrade-to-team" onClick={() => onUpgrade()}>
        Upgrade
      </Link>
      {/* Use `&nbsp;` to prevent text wrapping from making "Upgrade" a widow/orphan */}
      &nbsp;to regain your access to unlimited users, shared app connections,
      premier support, and more
    </Alert>
  );
};
